import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  YoutubeIcon,
} from "Components/Icons";
import trusted from "../../Assets/homev2/footer-trusted-partner.png";

import SimpleNavbar from "Components/SimpleNavbar";

const CalendlyThankYou = () => {
  return (
    <div id="home" className="h-full w-full ">
      {/* <section className="bg-black w-full h-20 border-b border-b-gray-300 border-opacity-20 flex items-center justify-center">
        <img src={require('Assets/logo.png')} alt="Salesmrkt" height={30} width={160} />
      </section> */}

      <section
        style={{ backgroundImage: "url('/bg-gradient-leadcare.png')" }}
        className="bg-cover bg-no-repeat text-black flex flex-col h-screen w-full justify-center items-center px-5"
      >
        <div className="text-[45px] font-bold mb-2 text-center sm:text-left">
          Thank You for Your Submission
        </div>
        <div className="mb-8 text-center sm:text-left">
          Schedule a call with us to discuss your video and content needs.
        </div>
        <a
          href=" https://calendly.com/salesbox-meet/video-ondemand-services"
          target="_blank"
          className="bg-brand-green text-black flex   mb-16 justify-center items-center text-xl md:text-3xl font-bold lg:h-18 rounded-full px-20 border border-brand-green hover:border-black hover:bg-transparent transition-all duration-200 ease-in-out py-5 whitespace-nowrap"
        >
          Schedule a Call
        </a>
        <div className="flex flex-col max-w-[700px]">
          <img
            src={require("Assets/homev2/hero-image.png")}
            alt=""
            className="mx-10"
          />
          <div className="bg-black relative w-full rounded-full py-7 px-5 flex flex-row items-center justify-center gap-5 lg:gap-10">
            <div className="uppercase tracking-widest  text-white lg:text-[20px]">
              Find us on
            </div>
            <div className="flex  items-center gap-2  lg:gap-5  text-white">
              <a
                href="https://www.youtube.com/@salesmrkt"
                target="_blank"
                rel="noreferrer"
              >
                <YoutubeIcon />
              </a>
              <a
                href="https://www.instagram.com/salesmrkt_/"
                target="_blank"
                rel="noreferrer"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://www.facebook.com/Salesmrkt.B2B.Marketplace"
                target="_blank"
                rel="noreferrer"
              >
                <FacebookIcon />
              </a>
              <a
                href="https://www.linkedin.com/company/sales-mrkt/"
                target="_blank"
                rel="noreferrer"
              >
                <LinkedInIcon />
              </a>
            </div>
            <img
              src={trusted}
              alt="Trusted Partner"
              className="max-w-[40px] lg:max-w-[60px] absolute right-5 top-1/2 -translate-y-1/2"
            />
          </div>
        </div>
      </section>
      <SimpleNavbar />
    </div>
  );
};

export default CalendlyThankYou;
